import { Button, Col, Popover, Row, Typography } from 'antd';
import { getCurrency, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import UserListComponent from '../user_list_component/UserListComponent';
import { EmptyState } from '../empty_state/EmptyState';
import * as React from 'react';
import { defaultTier } from '../../utils/ApprovalHierarchyUtils';

export function ApprovalHierarchyPreview({
	approvalHierarchy,
	style,
	currentUser,
	token,
	editClick,
	isNTEBased,
}) {
	const tiers = nullSafeGet('tierDetails.0', approvalHierarchy)
		? nullSafeGetOrElse('tierDetails', approvalHierarchy, []).map((tier, i) => ({
				id: i,
				...tier,
		  }))
		: [defaultTier];
	const currency = getCurrency({ currentUser });

	let lastAmount;
	return (
		<Row type="flex" className="rowSpacing RowBody">
			<Col>
				{approvalHierarchy && approvalHierarchy.id ? (
					tiers.map((tier, i, tiers) => {
						const isNotLastElement = i < nullSafeGetOrElse('length', tiers, 0) - 1;
						const escalationElement =
							tier.daysAfterEscalation > -1 && isNotLastElement ? (
								<Popover
									content={
										tier.daysAfterEscalation > 0
											? `Pending approvals will automatically escalate to the next tier in ${nullSafeGet(
													'daysAfterEscalation',
													tier
											  )} day${tier.daysAfterEscalation > 1 ? 's' : ''}.`
											: `Pending approvals will automatically escalate to the next tier immediately.`
									}
								>
									<div className={'UsersContainerEscalation'}>
										<i className="icons8-font icons8-stairs-up"></i>
										<Typography.Text className={'UsersContainerEscalationLabel ml-2'}>
											{tier.daysAfterEscalation} day{tier.daysAfterEscalation > 1 ? 's' : ''}
										</Typography.Text>
									</div>
								</Popover>
							) : undefined;
						lastAmount =
							nullSafeGetOrElse('amountUpto', tiers[i - 1], 0) === tier.amountUpto
								? lastAmount
								: nullSafeGetOrElse('amountUpto', tiers[i - 1], 0);
						return (
							<div key={tier.id.toString()} className={'UsersContainer'} style={style}>
								<div className={'UsersContainerLabel'}>
									<span>
										<span>{tier.name && tier.name !== '' ? tier.name : `Tier ${tier.label}`}</span>
										{isNTEBased ? (
											<Typography.Text className={'AmountLabel mr-8'}>
												{tiers.length - 1 !== i
													? i === 0
														? `${currency.format(0, 0)} to ${currency.format(tier.amountUpto, 0)}`
														: `${currency.format(lastAmount, 0)} to ${currency.format(
																tier.amountUpto,
																0
														  )}`
													: `Over ${currency.format(
															tiers.length > 1 ? tiers[i - 1].amountUpto : 0,
															0
													  )}`}
											</Typography.Text>
										) : null}
									</span>
									<span className={'ml-auto flex'}>{escalationElement}</span>
								</div>
								<UserListComponent
									users={tier.approvers}
									rightItems={null}
									token={token}
									style={style}
									allowRemove={false}
									removeUser={() => {}}
									trailingItems={[]}
									emptyState={
										<span className={'ml-2, mt-1.5'}>No users have been added to this tier!</span>
									}
								/>
							</div>
						);
					})
				) : (
					<EmptyState
						graphic={
							<img
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/bank terminal.svg"
							/>
						}
						headline={"You haven't set up this Approval Hierarchy yet!"}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 440, marginBottom: 16 }}>
									<Button
										style={{ marginLeft: 16 }}
										type="primary"
										size="large"
										onClick={editClick}
									>
										{nullSafeGet('tierDetails.0', approvalHierarchy)
											? 'Update Approval Hierarchy'
											: 'Create Approval Hierarchy'}
									</Button>
								</div>
							</div>
						}
					/>
				)}
			</Col>
		</Row>
	);
}
